import React, { Component } from "react";

interface Props extends JSX.ElementChildrenAttribute {}

interface State {
  toggleSidebar: () => void;
  compactView: boolean,
  activeTab: string,
  setActiveTab: (activeTab: string) => void
}

export enum Views {
  HOME = "/",
  CLINICAL_DATA_RECORD = "/clinical-data-record",
  PATIENT_CENTRAL = "/patient-central",
  LAB_CENTRAL = "/lab-central",
  DASHBOARD = "/dashboard",
  GUARANTORS = "/guarantors",
  DOCTORS = "/doctors",
  MEDICAMENTS = "/medicaments",
  TARIFF = "/tariff",
  BILLING = "/billing",
  SETTINGS = "/settings",
  USER_SETTINGS = "/user-settings"
}

export const SidebarContext = React.createContext<State>({
  toggleSidebar: () => {},
  compactView: false,
  activeTab: Views.HOME,
  setActiveTab: () => {}
});

export class SidebarProvider extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      toggleSidebar: this.toggleSidebar,
      compactView: false,
      activeTab: Views.HOME,
      setActiveTab: this.setActiveTab
    };
  }

  toggleSidebar = () => {
    this.setState(({ compactView }: State) => ({
      compactView: !compactView
    }))
  };

  setActiveTab = (activeTab: string) => {

    const uriRoot = activeTab.split("/")[1];
    const root = `/${uriRoot}`;

    this.setState({
      activeTab: Object.values(Views).includes(root) ? root : Views.HOME
    })
  };

  render() {
    return (
        <SidebarContext.Provider value={this.state} >
            {this.props.children}
        </SidebarContext.Provider>
    )
  }
}

export interface SidebarConsumerRenderProps extends State {}

export const withSidebarContext = (Component: typeof React.Component | React.FunctionComponent<any> ) => {
  return (props: any) => (
      <SidebarContext.Consumer>
        {({...sidebarProps}: SidebarConsumerRenderProps) => {
          return <Component {...props} {...sidebarProps} />
        }}
      </SidebarContext.Consumer>
  );
};
